import type { AddressSearchTrackingData } from '~/composables/api/usePrebookingTracking'
import * as Sentry from '@sentry/vue'

/**
 * Server-side only tracking utility - directly calls external tracking service
 * @param endpointPath - The full endpoint path (e.g., 'api/tracking/track-address-search')
 * @param data - The tracking data to send
 * @returns Promise that resolves when tracking is complete
 */
export async function trackServerSide(
  endpointPath: string,
  data: AddressSearchTrackingData | Partial<AddressSearchTrackingData>,
): Promise<void> {
  try {
    const config = useRuntimeConfig()

    await $fetch(`${config.public.apiBaseUrl}/${endpointPath}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    })

    // Only log success on server to avoid client console pollution
    if (import.meta.server) {
      Sentry.captureMessage(`✅ Server-side tracking successful: ${endpointPath}`, 'info')
    }
  }
  catch (error: any) {
    Sentry.captureException(error)
  }
}
